require('flatpickr/');
export default class FlatpickrFormatter {
    public static transformFormat(format: string) {
        return format.replace('g', 'h')
            .replace('s', 'S')
            .replace('G', 'H')
            .replace('A', 'K');
    }
}
